export var SyncStatus;
(function (SyncStatus) {
    SyncStatus[SyncStatus["SYNCED"] = 1] = "SYNCED";
    SyncStatus[SyncStatus["PENDING_PUSH"] = 2] = "PENDING_PUSH";
    SyncStatus[SyncStatus["PUSHING"] = 3] = "PUSHING";
})(SyncStatus || (SyncStatus = {}));
export var PushResultStatus;
(function (PushResultStatus) {
    PushResultStatus[PushResultStatus["SYNCED"] = 1] = "SYNCED";
    PushResultStatus[PushResultStatus["CONFLICT"] = 2] = "CONFLICT";
})(PushResultStatus || (PushResultStatus = {}));
